<div class="p-col-12">
    <div>
        <p-table  #dt  [value]="items" selectionMode="mutiple" 
                  dataKey="id" [(selection)]="selectedItems" [metaKeySelection]="true" [globalFilterFields]="globalFilter"
                  [paginator]="true" [rows]="10" [responsive]="true" paginatorPosition="bottom">

            <ng-template pTemplate="caption">
                <div class="p-grid">
                    <div class="p-md-6">
                        <button type="button" pButton icon="pi pi-plus" *ngIf="canAdd" iconPos="left" routerLink="new" label="New" style="margin-right: 0.5em;" class="p-mr-2 p-mb-2"></button>
                        <button type="button" pButton (click)='active()' *ngIf="selectedItems.length > 0 && canActive "  label="Enable" icon="pi pi-check" iconPos="left" style="margin-right: 0.5em;" class="p-button-success p-mb-2" ></button>
                        <button type="button" pButton (click)='desactive()' *ngIf="selectedItems.length > 0 && canActive"  label="Disable" icon="pi pi-times" iconPos="left" style="margin-right: 0.5em;" class="p-button-warning p-mb-2" ></button>
                        <button type="button" pButton  icon="pi pi-trash" (click)='delete()' *ngIf="selectedItems.length > 0 && canRemove"  label="Delete" icon="pi pi-times" iconPos="left" style="margin-right: 0.5em;" class="p-button-danger p-mb-2"></button>
                    </div>
                    <div class="p-md-3 p-text-right">
                        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                            <h5 class="p-m-2"><span>{{title}} ({{items.length}})</span></h5>
                        </div>
                    </div>
                    <div class="p-md-3 p-fluid">
                        <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                            <span class="p-input-icon-left">
                                <i class="pi pi-search"></i>
                                <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                            </span>
                        </div>
                    </div>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th [ngStyle]="{'width': '50px'}">
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <th *ngFor="let col of cols" [ngStyle]="{'width': col.width}" [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                    <p-columnFilter *ngIf='col.filtered' [type]="col.type != null ? col.type : 'text'"
                                    [field]="col.field" display="menu" 
                                    matchMode="contains" 
                                    [showMatchModes]="col.type =='text' ? false : true" 
                                    [showOperator]="col.type =='text' ? false : true" 
                                    [showAddButton]="col.type =='text' ? false : true"></p-columnFilter>
                </th>
                <th [ngStyle]="{'width': '80px'}">
                    Active
                    <p-columnFilter type="boolean" field="active" display="menu"></p-columnFilter>
                </th>
                <th [ngStyle]="{'width': '50px'}"></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
                <tr [pSelectableRow]="item" [ngClass]="'item-active-'+item.active">
                    <td>
                <p-tableCheckbox [value]="item"></p-tableCheckbox>
                </td>
                <td *ngFor="let col of cols">
                    {{col.format ? col.format(get(item,col.field)) : get(item,col.field)}}
                </td>
                <td>
                    <p-inputSwitch [(ngModel)]="item.active" [readonly]='false' (onChange)='stateChange(item)'></p-inputSwitch>
                </td>
                <td>
                    <p-button [routerLink]="getPath() +'/'+item.id" icon="pi pi-arrow-down"></p-button>
                </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>